const mr = {
  nav: {
    home: "मुख्यपृष्ठ",
    salons: "सलून",
    membership: "सदस्यत्व",
    shop: "दुकान",
    academy: "अकॅडमी",
    blog: "जर्नल",
    login: "लॉगिन",
    logout: "लॉग आउट",
    dashboard: "डॅशबोर्ड",
    bookings: "माझी बुकिंग्ज",
    loyalty: "लॉयल्टी",
    profile: "प्रोफाइल",
    orders: "माझे ऑर्डर्स",
    chat: "संभाषण",
    notifications: "सूचना",
    partner: "पार्टनर",
    admin: "अ‍ॅडमिन",
    partner_panel: "पार्टनर पॅनेल",
    admin_panel: "अ‍ॅडमिन पॅनेल",
    login_register: "लॉगिन / नोंदणी",
    skip_to_content: "मजकुराकडे जा",
    account_menu: "खाते मेनू",
    primary_nav: "प्राथमिक",
    mobile_nav: "मोबाइल नेव्हिगेशन",
    ai_advisor: "AI सल्लागार",
    cart: "शॉपिंग कार्ट",
  },
  footer: {
    tagline: "भारतातील प्रीमियम सलून बुकिंग प्लॅटफॉर्म — लक्झरी सौंदर्य तुमच्या बोटांच्या टोकावर.",
    company: "कंपनी",
    about: "आमच्याबद्दल",
    how_it_works: "हे कसे कार्य करते",
    partners: "पार्टनर्ससाठी",
    stylists: "स्टायलिस्टसाठी",
    careers: "करिअर",
    contact: "संपर्क",
    support: "सहाय्य",
    faq: "वारंवार विचारले जाणारे प्रश्न",
    help: "मदत केंद्र",
    privacy: "गोपनीयता धोरण",
    terms: "सेवा अटी",
    refund: "परतावा धोरण",
    services: "सेवा",
    salons: "सलून",
    membership: "सदस्यत्व",
    shop: "दुकान",
    academy: "अकॅडमी",
    connect: "कनेक्ट व्हा",
    newsletter_title: "आमच्या वृत्तपत्रात सामील व्हा",
    newsletter_sub: "सौंदर्य टिप्स, खास ऑफर्स, कोणताही स्पॅम नाही.",
    newsletter_placeholder: "तुमचा ईमेल",
    newsletter_cta: "सदस्यता घ्या",
    copyright: "© {{year}} Fayriza. सर्व हक्क राखीव.",
    made_in: "भारतात निर्मित",
  },
  home: {
    hero_eyebrow: "भारतातील प्रीमियम सलून नेटवर्क",
    hero_title: "तुमचा परिपूर्ण सलून अनुभव शोधा",
    hero_subtitle: "तुमच्या जवळील टॉप-रेटेड सलूनमध्ये अपॉइंटमेंट बुक करा — लक्झरी, सोय आणि काळजी.",
    search_placeholder: "सलून, सेवा किंवा स्टायलिस्ट शोधा…",
    search_cta: "सलून शोधा",
    featured_salons: "निवडक सलून",
    browse_all: "सर्व पहा",
    view_all: "सर्व पहा",
    categories_title: "श्रेणी एक्सप्लोर करा",
    categories_sub: "प्रत्येक प्रसंगासाठी खास निवडलेल्या सेवा",
    why_title: "Fayriza का?",
    why_sub: "सुरुवातीपासून शेवटपर्यंत एक प्रीमियम अनुभव",
    why_1_title: "पडताळलेले सलून",
    why_1_body: "प्रत्येक पार्टनर सलून काळजीपूर्वक निवडला आणि गुणवत्तेसाठी तपासला जातो.",
    why_2_title: "त्वरित बुकिंग",
    why_2_body: "रिअल-टाइम उपलब्धता, काही सेकंदात पुष्टी.",
    why_3_title: "सुरक्षित पेमेंट्स",
    why_3_body: "Razorpay-समर्थित, परताव्याच्या संरक्षणासह व्यवहार.",
    why_4_title: "लॉयल्टी आणि बक्षीसे",
    why_4_body: "प्रत्येक भेटीवर पॉइंट्स मिळवा, फायद्यांसाठी रिडीम करा.",
    testimonials_title: "आमच्या समुदायाचे आवडते",
    cta_title: "चमकण्यास तयार आहात?",
    cta_sub: "हजारो Fayriza सदस्यांमध्ये सामील व्हा.",
    cta_btn: "सुरू करा",
  },
  salons: {
    title: "सर्व सलून",
    subtitle: "तुमच्या जवळील प्रीमियम पार्टनर सलून ब्राउझ करा",
    filter: "फिल्टर",
    sort: "क्रमवारी",
    sort_relevance: "संबंधितता",
    sort_rating: "सर्वोच्च रेटेड",
    sort_price_asc: "किंमत: कमीपासून जास्त",
    sort_price_desc: "किंमत: जास्तपासून कमी",
    sort_nearest: "सर्वात जवळ",
    search_placeholder: "नाव किंवा परिसराने शोधा…",
    categories_all: "सर्व",
    city_all: "सर्व शहरे",
    price_range: "किंमत श्रेणी",
    open_now: "आता उघडे",
    no_results_title: "तुमच्या फिल्टरशी जुळणारे सलून नाहीत",
    no_results_sub: "फिल्टर काढून टाकून किंवा वेगळ्या परिसरात शोधून पहा.",
    clear_filters: "फिल्टर काढा",
    showing: "{{count}} सलून दाखवत आहे",
    loading: "सलून लोड होत आहेत…",
    book_now: "आता बुक करा",
    from: "पासून",
    per_service: "प्रति सेवा",
    results: "निकाल",
    filters_title: "फिल्टर",
    reset_all: "सर्व रीसेट करा",
    category: "श्रेणी",
    min_rating: "किमान रेटिंग",
    any_rating: "कोणतेही रेटिंग",
    for_gender: "कोणासाठी",
    gender_women: "महिला",
    gender_men: "पुरुष",
    gender_unisex: "सर्वांसाठी",
    cat_bridal: "नववधू",
    cat_spa: "स्पा",
  },
  salon: {
    book_now: "आता बुक करा",
    message: "संदेश",
    favourite: "आवडते",
    unfavourite: "आवडते काढा",
    share: "शेअर करा",
    directions: "दिशा",
    call: "कॉल करा",
    services: "सेवा",
    stylists: "स्टायलिस्ट",
    reviews: "पुनरावलोकने",
    availability: "उपलब्धता",
    gallery: "गॅलरी",
    about: "परिचय",
    working_hours: "कामाचे तास",
    amenities: "सुविधा",
    contact: "संपर्क",
    overview: "विहंगावलोकन",
    location: "स्थान",
    reviews_count: "{{count}} पुनरावलोकने",
    rating_out_of: "5 पैकी {{rating}}",
    select_service: "बुक करण्यासाठी सेवा निवडा",
    duration: "कालावधी",
    minutes: "{{min}} मि",
    open: "उघडे",
    closed: "बंद",
    closes_at: "{{time}} वाजता बंद होते",
    opens_at: "{{time}} वाजता उघडते",
  },
  booking: {
    title: "अपॉइंटमेंट बुक करा",
    step_services: "सेवा",
    step_stylist: "स्टायलिस्ट",
    step_datetime: "दिनांक आणि वेळ",
    step_review: "पुनरावलोकन",
    step_pay: "पेमेंट",
    select_services: "सेवा निवडा",
    select_stylist: "स्टायलिस्ट निवडा",
    any_stylist: "कोणताही उपलब्ध स्टायलिस्ट",
    select_date: "दिनांक निवडा",
    select_time: "वेळ निवडा",
    no_slots: "या दिनांकासाठी कोणतेही स्लॉट उपलब्ध नाहीत",
    try_other_date: "वेगळ्या दिनांकाचा प्रयत्न करा",
    confirm: "बुकिंग पक्के करा",
    cancel: "बुकिंग रद्द करा",
    reschedule: "पुन्हा वेळ ठरवा",
    subtotal: "उप-एकूण",
    discount: "सवलत",
    tax: "कर आणि शुल्क",
    total: "एकूण",
    pay_now: "आता पैसे द्या",
    pay_at_salon: "सलूनमध्ये पैसे द्या",
    use_wallet: "वॉलेट वापरा",
    apply_offer: "ऑफर लागू करा",
    offer_placeholder: "कोड टाका",
    apply: "लागू करा",
    remove: "काढा",
    booking_confirmed: "बुकिंग पक्की झाली!",
    booking_cancelled: "बुकिंग रद्द झाली",
    booking_ref: "बुकिंग आयडी",
    when: "केव्हा",
    where: "कुठे",
    who: "यांच्यासोबत",
    notes: "टिप्पणी जोडा (ऐच्छिक)",
    notes_placeholder: "अ‍ॅलर्जी, प्राधान्ये…",
    upcoming: "आगामी",
    past: "मागील",
    cancelled: "रद्द झालेली",
    view_details: "तपशील पहा",
    download_receipt: "पावती डाउनलोड करा",
    rate_visit: "या भेटीला रेटिंग द्या",
  },
  auth: {
    login_title: "पुन्हा स्वागत आहे",
    login_sub: "Fayriza वर सुरू ठेवण्यासाठी साइन इन करा",
    register_title: "खाते तयार करा",
    register_sub: "भारताच्या प्रीमियम सलून नेटवर्कमध्ये सामील व्हा",
    email: "ईमेल",
    email_placeholder: "you@example.com",
    password: "पासवर्ड",
    password_placeholder: "किमान 8 अक्षरे",
    phone: "फोन नंबर",
    phone_placeholder: "10 अंकी मोबाइल नंबर",
    name: "पूर्ण नाव",
    name_placeholder: "तुमचे नाव",
    otp: "OTP टाका",
    otp_placeholder: "6 अंकी कोड",
    send_otp: "OTP पाठवा",
    verify_otp: "सत्यापित करा",
    resend_otp: "OTP पुन्हा पाठवा",
    resend_in: "{{s}} सेकंदात पुन्हा पाठवा",
    login_cta: "साइन इन",
    register_cta: "खाते तयार करा",
    forgot_password: "पासवर्ड विसरलात?",
    reset_password: "पासवर्ड रीसेट करा",
    reset_sub: "तुमचा ईमेल टाका, आम्ही रीसेट लिंक पाठवू",
    reset_sent: "रीसेट लिंक तुमच्या ईमेलवर पाठवली आहे",
    new_password: "नवीन पासवर्ड",
    confirm_password: "पासवर्डची पुष्टी करा",
    social_login: "किंवा यासह सुरू ठेवा",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "ईमेल सत्यापित करा",
    verify_email_sub: "आम्ही {{email}} वर सत्यापन लिंक पाठवली आहे",
    resend_email: "सत्यापन ईमेल पुन्हा पाठवा",
    accept_terms: "मी अटी आणि गोपनीयता धोरणास सहमत आहे",
    switch_to_register: "खाते नाही?",
    switch_to_register_cta: "नोंदणी करा",
    switch_to_login: "आधीच खाते आहे?",
    switch_to_login_cta: "साइन इन करा",
    remember_me: "मला लक्षात ठेवा",
    phone_or_email: "फोन किंवा ईमेल",
    use_phone: "त्याऐवजी फोन वापरा",
    use_email: "त्याऐवजी ईमेल वापरा",
  },
  profile: {
    title: "माझे प्रोफाइल",
    edit_profile: "प्रोफाइल संपादित करा",
    change_password: "पासवर्ड बदला",
    avatar: "प्रोफाइल फोटो",
    upload_photo: "फोटो अपलोड करा",
    name: "पूर्ण नाव",
    phone: "फोन नंबर",
    email: "ईमेल",
    dob: "जन्मदिनांक",
    gender: "लिंग",
    gender_male: "पुरुष",
    gender_female: "स्त्री",
    gender_other: "इतर",
    address: "पत्ता",
    city: "शहर",
    pincode: "पिनकोड",
    save: "बदल जतन करा",
    saved: "प्रोफाइल अपडेट झाले",
    current_password: "सध्याचा पासवर्ड",
    current_password_placeholder: "सध्याचा पासवर्ड टाका",
    new_password: "नवीन पासवर्ड",
    new_password_placeholder: "किमान 8 अक्षरे",
    password_changed: "पासवर्ड यशस्वीरीत्या बदलला",
  },
  dashboard: {
    title: "डॅशबोर्ड",
    welcome: "पुन्हा स्वागत आहे, {{name}}",
    upcoming_bookings: "आगामी बुकिंग्ज",
    no_upcoming: "कोणतीही आगामी अपॉइंटमेंट नाही",
    book_a_salon: "सलून बुक करा",
    favourites: "आवडते सलून",
    no_favourites: "तुम्ही अजून कोणतेही सलून आवडते म्हणून चिन्हांकित केलेले नाहीत",
    loyalty_points: "लॉयल्टी पॉइंट्स",
    wallet_balance: "वॉलेट शिल्लक",
    recent_activity: "अलीकडील क्रियाकलाप",
    quick_actions: "त्वरित क्रिया",
    view_all: "सर्व पहा",
    manage_membership: "सदस्यत्व व्यवस्थापित करा",
    top_up_wallet: "वॉलेटमध्ये पैसे भरा",
    refer_friend: "मित्राला रेफर करा",
  },
  common: {
    loading: "लोड होत आहे…",
    error: "काहीतरी चूक झाली",
    retry: "पुन्हा प्रयत्न करा",
    no_results: "कोणतेही निकाल सापडले नाहीत",
    search: "शोधा",
    filter: "फिल्टर",
    sort: "क्रमवारी",
    view_all: "सर्व पहा",
    see_more: "अधिक पहा",
    see_less: "कमी पहा",
    back: "मागे",
    next: "पुढे",
    previous: "मागील",
    submit: "सबमिट करा",
    cancel: "रद्द करा",
    delete: "हटवा",
    edit: "संपादित करा",
    save: "जतन करा",
    close: "बंद करा",
    confirm: "पक्के करा",
    continue: "सुरू ठेवा",
    yes: "होय",
    no: "नाही",
    skip: "वगळा",
    optional: "ऐच्छिक",
    required: "आवश्यक",
    from: "पासून",
    per: "प्रति",
    to: "पर्यंत",
    and: "आणि",
    or: "किंवा",
    learn_more: "अधिक जाणून घ्या",
    coming_soon: "लवकरच येत आहे",
    currency: "₹",
    minutes_short: "मि",
    hours_short: "तास",
    km: "किमी",
    away: "अंतरावर",
    stars: "तारे",
  },
  loyalty: {
    title: "Fayriza लॉयल्टी",
    subtitle: "प्रत्येक भेटीवर पॉइंट्स मिळवा, बक्षीसांसाठी रिडीम करा",
    points: "पॉइंट्स",
    available_points: "उपलब्ध पॉइंट्स",
    total_earned: "एकूण मिळवले",
    total_redeemed: "एकूण रिडीम केले",
    redeem: "रिडीम करा",
    history: "पॉइंट्स इतिहास",
    rewards: "बक्षीसे",
    tier: "श्रेणी",
    how_it_works: "हे कसे कार्य करते",
    earn_title: "कमवा",
    earn_body: "प्रत्येक ₹10 खर्चावर 1 पॉइंट. Gold वर 2×, Platinum वर 3×.",
    redeem_title: "रिडीम करा",
    redeem_body: "पॉइंट्स वॉलेट क्रेडिट, मोफत सेवा किंवा पार्टनर फायद्यांसाठी वापरा.",
    empty_history: "अजून कोणताही पॉइंट्स क्रियाकलाप नाही",
    empty_rewards: "सध्या कोणतीही बक्षीसे उपलब्ध नाहीत",
  },
  wallet: {
    title: "Fayriza वॉलेट",
    subtitle: "एकदा पैसे भरा, बिनधास्त बुक करा",
    balance: "शिल्लक",
    available: "उपलब्ध",
    topup: "टॉप अप",
    topup_cta: "पैसे जोडा",
    topup_amount: "रक्कम",
    history: "व्यवहार इतिहास",
    empty_history: "अजून कोणतेही व्यवहार नाहीत",
    credit: "क्रेडिट",
    debit: "डेबिट",
    refund: "परतावा",
  },
  membership: {
    eyebrow: "खास प्रवेश",
    hero_title: "Fayriza सदस्यत्व योजना",
    hero_sub: "भारतातील 500+ प्रीमियम सलूनमध्ये खास सवलती, प्राधान्य बुकिंग आणि लक्झरी फायदे अनलॉक करा.",
    plans: "सदस्यत्व योजना",
    subscribe: "सदस्यता घ्या",
    cancel: "सदस्यत्व रद्द करा",
    current: "सध्याची योजना",
    gold: "Gold",
    silver: "Silver",
    platinum: "Platinum",
    per_year: "/वर्ष",
    per_month_approx: "≈ ₹{{amount}}/महिना",
    cancel_anytime: "कधीही रद्द करा",
    choose_title: "तुमची योजना निवडा",
    choose_sub: "सर्व योजना वार्षिक शुल्काने आकारल्या जातात. योजना निवडा आणि त्वरित सक्रिय करण्यासाठी पुष्टी करा.",
    most_popular: "सर्वाधिक लोकप्रिय",
    get_plan: "{{plan}} घ्या",
    selected_proceed: "निवडले — पैसे देण्यासाठी पुढे जा →",
    processing: "प्रक्रिया होत आहे…",
    current_plan_label: "✓ सध्याची योजना",
    welcome_back: "पुन्हा स्वागत आहे, {{name}}!",
    member_label: "Fayriza {{tier}} सदस्य",
    expires_in: "{{days}} दिवसात संपेल",
    renews_on: "{{date}} रोजी नूतनीकरण होईल",
    your_discount: "तुमची सवलत",
    off_all: "सर्व सेवांवर सूट",
    expiring_warn: "तुमचे सदस्यत्व लवकरच संपत आहे. तुमच्या सवलती कायम ठेवण्यासाठी आता नूतनीकरण करा.",
    feature_comparison: "संपूर्ण वैशिष्ट्य तुलना",
    feature: "वैशिष्ट्य",
    benefits_500: "500+ पार्टनर सलून",
    benefits_instant: "त्वरित सक्रियकरण",
    benefits_cancel: "कधीही रद्द करा",
    benefits_refund: "7 दिवसांत पैसे परत",
    faq_title: "वारंवार विचारले जाणारे प्रश्न",
    faq_cancel_q: "मी माझे सदस्यत्व रद्द करू शकतो का?",
    faq_cancel_a: "होय. तुम्ही डॅशबोर्डमधून कधीही रद्द करू शकता. तुमच्या बिलिंग कालावधीच्या शेवटपर्यंत तुमचे फायदे कायम राहतात.",
    faq_all_salons_q: "सवलत सर्व सलूनला लागू होते का?",
    faq_all_salons_a: "होय — सवलत भारतातील सर्व 500+ पडताळलेल्या Fayriza पार्टनर सलूनमध्ये आपोआप लागू होते.",
    faq_refund_q: "7-दिवसांची पैसे परत हमी म्हणजे काय?",
    faq_refund_a: "सक्रियकरणाच्या 7 दिवसांच्या आत तुम्ही समाधानी नसाल, तर आम्ही तुमचे सदस्यत्व शुल्क पूर्णपणे परत करू — कोणतेही प्रश्न न विचारता.",
    faq_upgrade_q: "मी माझी योजना अपग्रेड करू शकतो का?",
    faq_upgrade_a: "होय. तुम्ही कधीही अपग्रेड करू शकता. उर्वरित कालावधीसाठी प्रमाणित फरक आकारला जाईल.",
    activated: "🎉 Fayriza {{plan}} सक्रिय झाले!",
    subscribe_failed: "सदस्यता अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
  },
  shop: {
    eyebrow: "Fayriza दुकान",
    hero_title: "प्रीमियम सौंदर्य आणि ग्रूमिंग उत्पादने",
    hero_sub: "निवडक व्यावसायिक दर्जाच्या आवश्यक वस्तू, तुमच्या दारापर्यंत पोहोचवलेल्या.",
    search_placeholder: "उत्पादने शोधा…",
    categories: "श्रेणी",
    all_products: "सर्व उत्पादने",
    add_to_cart: "कार्टमध्ये जोडा",
    added: "जोडले ✓",
    out_of_stock: "स्टॉकमध्ये नाही",
    checkout: "चेकआउट",
    cart: "कार्ट",
    cart_empty: "तुमची कार्ट रिकामी आहे",
    cart_empty_sub: "भरण्यासाठी खरेदी सुरू करा",
    products: "उत्पादने",
    orders: "माझे ऑर्डर्स",
    no_orders: "अजून कोणतेही ऑर्डर नाहीत",
    order_ref: "ऑर्डर आयडी",
    order_status: "स्थिती",
    order_placed: "दिले",
    order_shipped: "पाठवले",
    order_delivered: "पोहोचवले",
    order_cancelled: "रद्द केले",
    qty: "संख्या",
    remove: "काढा",
    subtotal: "उप-एकूण",
    shipping: "शिपिंग",
    tax: "कर",
    total: "एकूण",
    proceed_checkout: "चेकआउटला पुढे जा",
    shipping_address: "शिपिंग पत्ता",
    place_order: "ऑर्डर द्या",
    continue_shopping: "खरेदी सुरू ठेवा",
    product_details: "उत्पादन तपशील",
    description: "वर्णन",
    specifications: "तपशील",
    you_may_like: "तुम्हाला हेही आवडू शकते",
    related: "संबंधित उत्पादने",
  },
  academy: {
    eyebrow: "Fayriza अकॅडमी",
    hero_title: "भारतातील सर्वोत्तम स्टायलिस्टकडून शिका",
    hero_sub: "प्रमाणित तज्ज्ञांकडून शिकवलेले व्यावसायिक सौंदर्य आणि ग्रूमिंग अभ्यासक्रम. तुमच्या गतीने शिका, प्रमाणपत्रे मिळवा आणि तुमचे करिअर सुरू करा.",
    search_placeholder: "अभ्यासक्रम किंवा प्रशिक्षक शोधा…",
    stats_courses: "तज्ज्ञ अभ्यासक्रम",
    stats_students: "नोंदणीकृत विद्यार्थी",
    stats_rating: "सरासरी रेटिंग",
    stats_certificate: "प्रमाणपत्र समाविष्ट",
    all: "सर्व अभ्यासक्रम",
    makeup: "मेकअप",
    hair: "केस",
    skin: "त्वचा",
    nails: "नखे",
    grooming: "ग्रूमिंग",
    courses: "अभ्यासक्रम",
    course: "अभ्यासक्रम",
    enroll: "आता नोंदणी करा",
    enrolled: "नोंदणीकृत",
    modules: "मॉड्यूल्स",
    instructor: "प्रशिक्षक",
    duration: "कालावधी",
    level: "स्तर",
    level_beginner: "नवशिका",
    level_intermediate: "मध्यम",
    level_advanced: "प्रगत",
    certificate: "प्रमाणपत्र",
    no_courses: "तुमच्या फिल्टरशी जुळणारे अभ्यासक्रम नाहीत",
    my_enrollments: "माझे अभ्यासक्रम",
    continue_learning: "शिकणे सुरू ठेवा",
    completed: "पूर्ण झाले",
  },
  notifications: {
    title: "सूचना",
    empty: "तुम्ही सर्व पाहून पूर्ण केले आहे",
    empty_sub: "सध्या कोणत्याही नवीन सूचना नाहीत",
    mark_all_read: "सर्व वाचले म्हणून चिन्हांकित करा",
    just_now: "आत्ताच",
    minutes_ago: "{{n}} मि आधी",
    hours_ago: "{{n}} तास आधी",
    days_ago: "{{n}} दिवस आधी",
  },
  ai: {
    title: "Fayriza AI सल्लागार",
    subtitle: "AI द्वारे चालवलेल्या वैयक्तिक सौंदर्य शिफारसी.",
    placeholder: "त्वचा, केस, मेकअप याबद्दल काहीही विचारा…",
    send: "पाठवा",
    examples_title: "हे विचारून पहा",
    ex_1: "माझ्या चेहऱ्याच्या आकारासाठी सर्वोत्तम हेअरकट?",
    ex_2: "तेलकट त्वचेसाठी स्किनकेअर रुटीन",
    ex_3: "ब्रायडल मेकअप ट्रेंड्स 2026",
    thinking: "विचार करत आहे…",
    disclaimer: "सूचना केवळ माहितीसाठी आहेत. वैद्यकीय चिंतांसाठी तज्ज्ञांचा सल्ला घ्या.",
  },
  marketing: {
    about: {
      eyebrow: "आमची कहाणी",
      title: "सौंदर्य, पुन्हा कल्पिलेले",
      sub: "Fayriza एका साध्या कल्पनेतून जन्मले — भारत त्याच्या कलाकुसरीइतकाच सुसंस्कृत सलून बुकिंग अनुभव मिळण्यास पात्र आहे.",
      mission_title: "आमचे ध्येय",
      mission_body: "एक अखंड, विश्वासार्ह आणि लक्झरी प्लॅटफॉर्मद्वारे लाखो सौंदर्यप्रेमींना भारतातील सर्वोत्तम सलूनशी जोडणे.",
      vision_title: "आमची दृष्टी",
      vision_body: "एक असे जग जिथे प्रत्येकाला दर्जेदार सौंदर्य आणि निरोगीपणाच्या सेवा बोटांच्या टोकावर उपलब्ध असतील.",
      values_title: "आमची मूल्ये",
      value_1_title: "गुणवत्ता प्रथम",
      value_1_body: "प्रत्येक पार्टनर सलून पडताळला जातो आणि आमच्या प्रीमियम मानकांवर टिकवला जातो.",
      value_2_title: "ग्राहक-केंद्रित",
      value_2_body: "तुमचा अनुभव आमचा उत्तर तारा आहे — बुकिंगपासून नंतरच्या काळजीपर्यंत.",
      value_3_title: "पार्टनर्सला सक्षम करणे",
      value_3_body: "आमच्या सलून आणि स्टायलिस्ट्स वाढतात तेव्हा आम्ही वाढतो.",
      cta_title: "कहाणीचा भाग व्हा",
      cta_sub: "आजच Fayriza समुदायात सामील व्हा.",
    },
    how_it_works: {
      eyebrow: "हे कसे कार्य करते",
      title: "तीन पायऱ्यांत बुक करा",
      sub: "प्रीमियम सौंदर्य, कोणत्याही अंदाजाशिवाय.",
      step_1_title: "शोधा",
      step_1_body: "तुमच्या जवळील पडताळलेले सलून, सेवा आणि स्टायलिस्ट ब्राउझ करा.",
      step_2_title: "बुक करा",
      step_2_body: "तुम्हाला सोयीची वेळ निवडा — त्वरित पुष्टी.",
      step_3_title: "आनंद घ्या",
      step_3_body: "पॅम्पर व्हा. तुमच्या भेटीला रेटिंग द्या. बक्षीसे कमवा.",
      faq_title: "त्वरित प्रश्न",
    },
    partners: {
      eyebrow: "सलून मालकांसाठी",
      title: "Fayriza सोबत वाढा",
      sub: "नवीन ग्राहकांपर्यंत पोहोचा, रिकाम्या खुर्च्या भरा आणि आधुनिक सलून चालवा.",
      benefit_1_title: "अधिक ग्राहक",
      benefit_1_body: "भारतातील सर्वात मोठ्या प्रीमियम सौंदर्य प्रेक्षकांपर्यंत पोहोच.",
      benefit_2_title: "स्मार्ट बुकिंग",
      benefit_2_body: "एकाच डॅशबोर्डमधून वेळापत्रक, कर्मचारी आणि सेवा व्यवस्थापित करा.",
      benefit_3_title: "त्वरित पेमेंट्स",
      benefit_3_body: "सुरक्षित, जलद पेआउट्स — पाठपुरावा करण्याची गरज नाही.",
      cta: "पार्टनर व्हा",
    },
    stylists: {
      eyebrow: "स्टायलिस्टसाठी",
      title: "तुमचा ग्राहकवर्ग तयार करा",
      sub: "तुमचे काम दाखवा, ओळख मिळवा आणि तुमचे करिअर वाढवा.",
      cta: "स्टायलिस्ट म्हणून अर्ज करा",
    },
    careers: {
      eyebrow: "करिअर",
      title: "सौंदर्याच्या भविष्याला आकार द्या",
      sub: "आम्ही एक लहान टीम आहोत जी काहीतरी मोठे बांधत आहोत. सामील व्हायचे आहे?",
      openings_title: "उपलब्ध पदे",
      no_openings: "सध्या कोणतीही पदे उपलब्ध नाहीत. careers@fayriza.com वर आम्हाला कळवा.",
    },
    contact: {
      eyebrow: "संपर्कात रहा",
      title: "आम्हाला तुमच्याकडून ऐकायला आवडेल",
      sub: "प्रश्न, अभिप्राय किंवा भागीदारीच्या कल्पना — आम्ही सर्व ऐकायला तयार आहोत.",
      name: "तुमचे नाव",
      email: "तुमचा ईमेल",
      message: "संदेश",
      send: "संदेश पाठवा",
      sent: "धन्यवाद — आम्ही 24 तासांत परत येऊ.",
      support_email: "सहाय्य",
      partners_email: "पार्टनर्स",
      media_email: "मीडिया",
    },
    faq: {
      eyebrow: "मदत",
      title: "वारंवार विचारले जाणारे प्रश्न",
      sub: "सामान्य प्रश्नांची त्वरित उत्तरे.",
    },
    legal: {
      privacy_title: "गोपनीयता धोरण",
      terms_title: "सेवा अटी",
      refund_title: "परतावा धोरण",
      last_updated: "शेवटचे अपडेट {{date}}",
    },
  },
  errors: {
    network: "नेटवर्क त्रुटी — तुमचे कनेक्शन तपासा",
    unauthorised: "सुरू ठेवण्यासाठी कृपया साइन इन करा",
    forbidden: "तुम्हाला याचा प्रवेश नाही",
    not_found: "तुम्ही शोधत असलेले आम्हाला सापडले नाही",
    server: "सर्व्हर त्रुटी — कृपया नंतर पुन्हा प्रयत्न करा",
    validation: "कृपया हायलाइट केलेले फील्ड्स तपासा",
    generic: "काहीतरी चूक झाली",
    page_not_found_title: "पृष्ठ सापडले नाही",
    page_not_found_sub: "तुम्ही शोधत असलेले पृष्ठ हलवले गेले आहे किंवा यापुढे अस्तित्वात नाही.",
    go_home: "मुख्यपृष्ठावर जा",
  },
};

export default mr;
